import { createContext, useContext } from 'react';
import type { CurrentOperator, ResellerRole } from '@/auth/authContextValue';

export interface ResellerContextValue {
  /** The signed-in member with tmm-api's LIVE role applied (H §4.4). */
  operator: CurrentOperator;
  /** tmm-api `/me` `resellerName`. Null when the reseller has none. */
  resellerName: string | null;
  /** The app-bar identity: the reseller's brand (saas-auth `/brand`), else the product's. */
  brand: { name: string; logoUrl: string | null };
  /** Re-GET `/me` — after any `RESELLER_ROLE_FORBIDDEN`. Resolves to the live role, or `null`
   *  when the re-GET failed (the previous role stays). */
  reloadMe: () => Promise<ResellerRole | null>;
}

export const ResellerContext = createContext<ResellerContextValue | null>(null);

/** The loaded reseller. Must be called within a `ResellerProvider`. */
export function useReseller(): ResellerContextValue {
  const ctx = useContext(ResellerContext);
  if (!ctx) throw new Error('useReseller must be used within a ResellerProvider');
  return ctx;
}

/** The reseller context when mounted, else `null` (screens rendered outside the shell). */
export function useOptionalReseller(): ResellerContextValue | null {
  return useContext(ResellerContext);
}
